document.addEventListener('focusin', event => {
  let focusTrap = document.querySelector('.modal.in') || document.querySelector('.hoverboard.in') || document.querySelector('.open .dropdown-toggle + .dropdown-menu');
  if (focusTrap && !event.target.closest('.modal.in, .hoverboard.in, .dropdown-menu, .select2-container')) {
    $(focusTrap).find(':focusable').first().focus();
  }
});
